import styled from "styled-components";
import {JackpotWidgetLogoDefaultBox} from "./jackpot-widget-logo.default.box";

export const JackpotWidgetLogoMrGreenBox = styled(JackpotWidgetLogoDefaultBox)`
  display: ${({isDaily}) => isDaily ? "none" : "block"};
`;